import { z } from "zod";

export const stockCorrectionSchema = z.object({
  materialId: z.string().min(1).max(100),
  quantityDelta: z.coerce
    .number()
    .int()
    .min(-1_000_000)
    .max(1_000_000)
    .refine((value) => value !== 0, "调整数量不能为 0"),
  reason: z.string().trim().min(2, "请填写冲正原因").max(500),
});
